var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6678_25392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 12,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41668 13.0833L4.41668 8.08329C4.25001 7.91663 4.16668 7.74996 4.16668 7.49996C4.16668 7.24996 4.25001 7.08329 4.41668 6.91663C4.75001 6.58329 5.25001 6.58329 5.58334 6.91663L10 11.3333L14.4167 6.91663C14.75 6.58329 15.25 6.58329 15.5833 6.91663C15.9167 7.24996 15.9167 7.74996 15.5833 8.08329L10.5833 13.0833C10.25 13.4166 9.75001 13.4166 9.41668 13.0833Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6678_25392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(20) rotate(90)",
    fill: "#888888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGray400);
export default __webpack_public_path__ + "static/media/chevron_down_gray400.f57a7563127dae568ebb8451de64a702.svg";
export { ForwardRef as ReactComponent };